// Auto-generated by scripts/generate-version.js
export const UI_VERSION = "3.3.268";
